import { get } from 'lodash';
import { Button, InfoButton } from '../../../../../../common/components';
import displayCurrency from '../../../../../../helpers/displayCurrency';
import { Col, Row } from 'react-bootstrap';
import { Field } from 'redux-form';
import { UpgradeOptionsCheckbox } from '../../../PolicyUpgrades/components/UpgradeOptionsCheckbox';
import BenefitsModal from '../../../BenefitsModal';
import React from 'react';
import './UpgradesBox.scss';

const travel_dispute = [{ name: 'Travel Dispute', value: true }];
const esf = [{ name: 'End Supplier', value: true }];
const smart_luggage = [{ name: 'Smart Luggage', value: true }];

const getInfoText = (definition) => {
  if (definition?.b2b) {
    return definition.b2b;
  }
  if (definition) {
    return definition;
  }
  return '';
};

const Boltons = ({ show, boltonsInfo, addOnDefinitions, isPremiumAdjusting }) => {
  if (!show) {
    return null;
  }
  return (
    <Col sm={5}>
      <>
        <Row>
          <Col sm={10}>
            <div className="upgrades-box--add-options-title">
              Add the following options:
            </div>
          </Col>
        </Row>
        <BoltonField
          name={'data.attributes.metadata.options.travel_dispute'}
          checkboxValue={'travelDispute'}
          bolton={boltonsInfo?.travel_dispute}
          infoText={getInfoText(addOnDefinitions?.travelDisputeDefinition)}
          isPremiumAdjusting={isPremiumAdjusting}
          options={travel_dispute}
          // isGoldUpgraded={isGoldUpgraded}
          title={'Travel Dispute -'}
        />

        <BoltonField
          name={'data.attributes.metadata.options.end_supplier_failure'}
          checkboxValue={'esf'}
          bolton={boltonsInfo?.end_supplier_failure}
          infoText={getInfoText(addOnDefinitions.endSupplierFailureDefinition)}
          isPremiumAdjusting={isPremiumAdjusting}
          options={esf}
          // isGoldUpgraded={isGoldUpgraded}
          title={'End Supplier Failure -'}
        />

        <BoltonField
          name={'data.attributes.metadata.options.smart_luggage'}
          checkboxValue={'smartLuggage'}
          bolton={boltonsInfo?.smart_luggage}
          infoText={getInfoText(addOnDefinitions.smartLuggageDefinition)}
          isPremiumAdjusting={isPremiumAdjusting}
          options={smart_luggage}
          // isGoldUpgraded={isGoldUpgraded}
          title={'Smart Luggage -'}
        />
      </>
    </Col>
  );
};

const BoltonLabel = ({ infoText, title, isPremiumAdjusting, total }) => (
  <div>
    <InfoButton content={infoText} white />
    <strong>{title} </strong>
    {isPremiumAdjusting ? '*' : displayCurrency(total)} extra
  </div>
);

const BoltonField = ({
  bolton,
  checkboxValue,
  name,
  infoText,
  isPremiumAdjusting,
  // isGoldUpgraded,
  options,
  title,
}) => {
  if (!bolton) {
    return null;
  }
  return (
    <Field
      checkboxValue={checkboxValue}
      name={name}
      label={
        <BoltonLabel
          infoText={infoText}
          title={title}
          isPremiumAdjusting={isPremiumAdjusting}
          total={get(bolton, 'total')}
        />
      }
      labelSize={10}
      component={UpgradeOptionsCheckbox}
      //      isGold={isGoldUpgraded}
      options={options}
    />
  );
};

const UpgradeToGold = ({ show, benefits, upgradeInfo, isSaving, onUpgradeToGold }) => {
  if (!show) {
    return null;
  }
  const diff = get(upgradeInfo, 'amount.difference');
  const total = get(upgradeInfo, 'amount.total');
  if (
    Number.isNaN(diff) ||
    diff === undefined ||
    Number.isNaN(total) ||
    total === undefined
  ) {
    return null;
  }

  return (
    <Col sm={7}>
      <Row>
        <Col sm={12}>
          <div>
            <div className="upgrades-box--gold-benefits-upgrade-text">
              <BenefitsModal scheme={{}} benefits={benefits} />
              <span>
                Or Upgrade to Gold for Just{' '}
                <span className={'upgrades-box--total-text'}>
                  {displayCurrency(diff)} (Total {displayCurrency(total)}
                </span>
              </span>

              <span className="upgrades-box--inclusive-text">
                inclusive cover for Travel Dispute and End Supplier Failure)
              </span>
            </div>
            <Button
              className={'upgrades-box--upgrade-button'}
              label={'UPGRADE TO GOLD COVER'}
              disabled={isSaving}
              handleClick={onUpgradeToGold}
            />
          </div>
        </Col>
      </Row>
    </Col>
  );
};

const GoldUpgraded = ({ show, benefits, isSaving, onUpgradeToGold }) => {
  if (!show) {
    return null;
  }
  return (
    <div>
      <Col sm={12}>
        <div className="upgrades-box--upgraded-button-container">
          <div className="upgrades-box--gold-benefits-upgraded-text">
            <BenefitsModal scheme={{}} benefits={benefits} />
            You've upgraded to a GOLD package
          </div>

          <Button
            className={'upgrades-box--upgrade-button'}
            label={'UPGRADED'}
            disabled={isSaving}
            handleClick={onUpgradeToGold}
          />
        </div>
      </Col>
    </div>
  );
};

const UpgradesBox = ({
  addOnDefinitions,
  benefits,
  boltonsInfo,
  show,
  showBoltonOptions,
  showUpgrade,
  upgradeInfo,
  isPremiumAdjusting,
  isGoldUpgraded,
  isSaving,
  isMta,
  onUpgradeToGold,
}) => {
  if (!show) {
    return null;
  }

  return (
    <div className="upgrades-box">
      <Row>
        <Col sm={12} className="upgrades-box--title">
          Upgrades
        </Col>
      </Row>
      <Row>
        <Col sm={12}>
          <div className={'upgrades-box--container'}>
            <Row>
              <Boltons
                show={showBoltonOptions && !isGoldUpgraded}
                boltonsInfo={boltonsInfo}
                addOnDefinitions={addOnDefinitions}
                isPremiumAdjusting={isPremiumAdjusting}
              />

              <UpgradeToGold
                show={!isMta && showUpgrade && !isGoldUpgraded}
                benefits={benefits}
                isGoldUpgraded={isGoldUpgraded}
                isSaving={isSaving}
                onUpgradeToGold={onUpgradeToGold}
                upgradeInfo={upgradeInfo}
              />
              <GoldUpgraded
                show={!isMta && showUpgrade && isGoldUpgraded}
                benefits={benefits}
                isGoldUpgraded={isGoldUpgraded}
                isSaving={isSaving}
                onUpgradeToGold={onUpgradeToGold}
                upgradeInfo={upgradeInfo}
              />
            </Row>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default UpgradesBox;
